import React from 'react';

import LTIRoleBasedRouting from 'app/LTIRoleBasedRouting';
import PasswordRoleBasedRouting from 'app/PasswordRoleBasedRouting';

const withPlatformRouting = (props) => {
    const authVar = process.env.REACT_APP_AUTH;

    if (authVar === 'LTI') {
        return <LTIRoleBasedRouting {...props} />;
    } else if (authVar === 'PASSWORD') {
        return <PasswordRoleBasedRouting {...props} />;
    }
};

export default withPlatformRouting;
